<template>
  <div id="app">
    <!-- Global notification component -->
    <transition name="fade">
      <notification-component 
        v-if="showNotification" 
        :message="notificationMessage" 
        @close="showNotification = false"
      />
    </transition>

    <!-- Main content with route transitions -->
    <router-view v-slot="{ Component, route }">
      <transition :name="route.meta.transition || 'fade'">
        <component :is="Component" />
      </transition>
    </router-view>

    <!-- Global chat widget -->
    <chat-widget v-if="showChat" />
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'App',
  components: {
    NotificationComponent: () => import('@/components/ui/Notification.vue'),
    ChatWidget: () => import('@/components/ChatWidget.vue')
  },
  setup() {
    const showNotification = ref(false)
    const notificationMessage = ref('')
    const showChat = ref(false)

    // Initialize auth listener
    const initAuthListener = () => {
      // Implement your auth state listener here
      // Example:
      // auth.onAuthStateChanged(user => {
      //   if (user) {
      //     localStorage.setItem('authToken', user.accessToken)
      //   } else {
      //     localStorage.removeItem('authToken')
      //   }
      // })
    }

    // Show notification method
    const showNotificationMessage = (payload) => {
      showNotification.value = true
      notificationMessage.value = payload.message
      setTimeout(() => {
        showNotification.value = false
      }, 5000) // Hide after 5 seconds
    }

    // Global error handler
    const handleGlobalError = (error) => {
      showNotificationMessage({
        message: 'An unexpected error occurred',
        type: 'error'
      })
      console.error(error)
    }

    // Initialize when component is created
    initAuthListener()
    window.addEventListener('unhandledrejection', handleGlobalError)
    window.addEventListener('error', handleGlobalError)

    // Cleanup when component is unmounted
    const cleanup = () => {
      window.removeEventListener('unhandledrejection', handleGlobalError)
      window.removeEventListener('error', handleGlobalError)
    }

    return {
      showNotification,
      notificationMessage,
      showChat,
      handleGlobalError,
      cleanup
    }
  },
  beforeUnmount() {
    this.cleanup()
  }
}
</script>

<style>
/* Your existing styles remain unchanged */
</style>